import { render, staticRenderFns } from "./cookie_banner.vue?vue&type=template&id=1f4985bc&scoped=true"
import script from "./cookie_banner.vue?vue&type=script&lang=js"
export * from "./cookie_banner.vue?vue&type=script&lang=js"
import style0 from "./cookie_banner.vue?vue&type=style&index=0&id=1f4985bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4985bc",
  null
  
)

export default component.exports